import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { PolizaService } from '@providers/poliza.service';
import { Observable, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EmitirSuscripcionResolver implements Resolve<any> {
  constructor(private polizaService: PolizaService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const { p, p_webpay: pWebpay } = route.queryParams;
    if (p) {
      return this.polizaService.emitirSuscripcion(p);
    } else if (pWebpay) {
      return this.polizaService.emisionWebPay(pWebpay);
    }

    return throwError(
      () =>
        new Error(
          'No se encontró un parámetro válido (p o p_webpay) en la ruta'
        )
    );
  }
}
